module.exports = __webpack_public_path__ + "static/img/1.e5de4ed7.png";